import * as React from 'react';

import { Badge } from '@/components/ui/badge';

// status-badge.tsx — badge de STATUT DE COMPTE (DS sweep Cat 1). L'API porte un
// `tone` DS (recette AA-SAFE portée par le Badge status : tone jamais sur le
// texte) ; le LIBELLÉ FR passe en `children` et reste l'unique porteur
// d'information (WCAG 1.4.1). Les tables de mapping (supplier-labels /
// client-labels / stateBadge écran équipe) fournissent le couple { label, tone }.

/**
 * Tones de statut de compte couverts par le DS. Les 5 valeurs couvrent tous les
 * états applicatifs via un mapping canonique porté par les tables de libellés
 * (Actif→active, Suspendu/ResignatureRequise→suspended, Invité/Soumis→invited,
 * Inactif/Brouillon/Archivé→inactive, Refusé→refused).
 */
export type StatusTone =
  | 'active'
  | 'suspended'
  | 'invited'
  | 'inactive'
  | 'refused';

export function StatusBadge({
  tone,
  children,
}: {
  readonly tone: StatusTone;
  readonly children: React.ReactNode;
}): React.JSX.Element {
  // withDot : point coloré (aria-hidden) porté par le tone — renfort visuel, le
  // libellé texte (children) reste l'unique porteur d'information (WCAG 1.4.1).
  return (
    <Badge variant={tone} withDot>
      {children}
    </Badge>
  );
}
